import Box from '@mui/material/Box';
import { Outlet, useParams } from 'react-router';
import useGetAvatar from '@/hooks/useGetAvatar';
import { composeUri } from '@/utils/compose';
import { AVATARS } from '@/utils/CONST';
import CustomBlock from '@/components/common/custom-block/custom-block';
import DashboardsInfoBox from '@/components/common/dashboards-info-box/dashboards-info-box';

const ClientInformation = () => {
    const { clientId } = useParams();
    const { avatar, isLoading } = useGetAvatar({
        avatarUriId: composeUri(AVATARS, clientId),
        filters: {
            'serialization_groups[0]': 'read_avatar_root',
        },
    });

    return (
        <Box
            data-cy={'client-information-container'}
            sx={{
                display: 'grid',
                gap: 1,
                gridTemplateColumns: '1fr',
                gridTemplateRows: '1fr',
                height: '100%',
                overflowY: 'auto',
            }}
        >
            <CustomBlock label={avatar?.name} loading={isLoading}>
                <Box
                    sx={{
                        p: 1,
                        display: 'grid',
                        gap: 3,
                        alignContent: 'start',
                    }}
                >
                    {avatar && (
                        <DashboardsInfoBox
                            avatar={avatar}
                            params={{
                                client_id: clientId,
                            }}
                            clientOrSite='client'
                        />
                    )}
                </Box>
            </CustomBlock>

            <Outlet />
        </Box>
    );
};

export default ClientInformation;
